import { marked } from 'marked';
import sanitizeHtml from 'sanitize-html';

const SANITIZE_CONFIG: sanitizeHtml.IOptions = {
  allowedTags: [
    'h1',
    'h2',
    'h3',
    'h4',
    'b',
    'i',
    'em',
    'strong',
    'u',
    's',
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'a',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
  },
  allowedSchemes: ['https', 'mailto', 'tel'],
  transformTags: {
    a: (tagName, attribs) => ({
      tagName,
      attribs: {
        ...attribs,
        ...(attribs.target === '_blank' && { rel: 'noopener noreferrer' }),
      },
    }),
  },
};

const SANITIZE_LINKS_ONLY_CONFIG: sanitizeHtml.IOptions = {
  ...SANITIZE_CONFIG,
  allowedTags: ['a'],
};

export const sanitize = (markdown: string): string =>
  sanitizeHtml(marked.parse(markdown, { async: false }), SANITIZE_CONFIG);

/**
 * Same allow-list as {@link sanitize}, for input that is **already HTML**.
 *
 * `sanitize` above runs Markdown through `marked` first. That is wrong for a
 * value SH stores as markup: `marked` would re-interpret the HTML — an `_` or a
 * `*` inside an address becomes emphasis, and blank lines between tags become
 * stray paragraphs. The imprint of a franchise Standort is such a value
 * (`Locations.impressum`: 389 of 390 are HTML), so it needs filtering without
 * the Markdown pass.
 */
export const sanitizeRichHtml = (html: string): string =>
  sanitizeHtml(html, SANITIZE_CONFIG);

export const sanitizeLinksOnly = (markdown: string): string =>
  sanitizeHtml(
    marked.parse(markdown, { async: false }),
    SANITIZE_LINKS_ONLY_CONFIG,
  );
